import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus-icon",
  "use": "icon-plus-icon-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-plus-icon\">\n<path d=\"M28.6868 1H1.35352V28.3333H28.6868V1Z\" fill=\"black\" stroke=\"#A7F900\" stroke-width=\"2\" />\n<path d=\"M15.999 22.6667V6.66675\" stroke=\"#A7F900\" stroke-width=\"2\" />\n<path d=\"M23.666 14.3333H7.66602\" stroke=\"#A7F900\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol